import React from 'react';
import * as d3 from 'd3';

function Tab (props) {

    const format = props.format,
        suggestion = props.suggestion,
        content = props.content,
        tracks = props.tracks,
        variables = props.variables;

    const selection = tracks.map(el => el.bb).includes(content) || tracks.map(el => el.beta).includes(content) || tracks.map(el => el.pip).includes(content) || tracks.map(el => el.fre).includes(content) || variables.map(el => el.content).includes(content)

    function suggest (a) {
        if      (a === "Position")          return ["pos"]
        else if (a === "Chromosome")        return ["chr"]
        else if (a === "Reference")         return ["ref"]
        else if (a === "Alternative")       return ["alt"]
        else if (a.includes("AF"))          return ["af", "allele", "fre"]
        else if (a.includes("Biobank"))     return ["pval", "meta_p", "het_p", "pv", "het"]
        else if (a.includes("Beta"))        return ["beta", 'bt']
        else if (a.includes("PIP"))         return ["prob", 'pip']
    }

    if (suggest(suggestion).some(el => content.toLowerCase().includes(el))) 
        return(
            <button className={selection ? "tabSelected" : "tabSuggested"}>
                {format('ky', content)}
            </button>
            )
    else return(
            <button className={selection ? "tabSelected" : "tabNormal"}>
                {format('ky', content)}
            </button>
            )
}
export default Tab;